import './bootstrap';
import '../css/app.css';

import { createApp, DefineComponent, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import AppLayout from '@/Layouts/AppLayout.vue';
import { createPinia } from 'pinia';
import { configureEcho } from '@laravel/echo-vue';
import { initSentry } from './sentry';

const appName = import.meta.env.VITE_APP_NAME || 'Spectre Social';

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  layout: () => AppLayout,
  resolve: (name) => resolvePageComponent(
    `./Pages/${name}.vue`,
    import.meta.glob<DefineComponent>('./Pages/**/*.vue'),
  ),
  setup({
    el, App, props, plugin,
  }) {
    configureEcho({
      broadcaster: 'pusher',
      key: props.initialPage.props.config.broadcasting.connections.pusher.key,
      wsPort: 443,
      wssPort: 443,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
      cluster: 'eu',
    });

    const app = createApp({ render: () => h(App, props) });

    initSentry(app);

    app
      .use(createPinia())
      .use(plugin)
      .mount(el!);
  },
  progress: {
    color: '#4B5563',
  },
});
